import React from 'react';
import QRGenerator from './QRGenerator';

const EmployeeBadges = ({ employees }) => {
  return (
    <div className="w-full max-w-7xl mx-auto p-4 sm:p-8 animate-fade-in-up">
      <div className="mb-8">
        <h2 className="text-3xl font-extrabold text-slate-100 bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-blue-500">
          Gafetes de Empleados
        </h2>
        <p className="text-slate-400 mt-2 text-sm max-w-2xl">
          Visualiza, imprime y descarga las credenciales QR de todos los colaboradores registrados en el sistema.
        </p>
      </div>

      {employees.length === 0 ? (
        <div className="p-8 text-center glass-card rounded-2xl border-slate-800/80">
          <p className="text-slate-400">No hay empleados registrados aún.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8">
          {employees.map((employee) => (
            <div key={employee.id} className="flex justify-center">
              <QRGenerator employee={employee} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default EmployeeBadges;
